/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { action, makeObservable, observable } from 'mobx';
import { MenuItemType } from '../../types/course/CourseMenuItem';
import { ModulePackage } from '../../types/course/ModulePackage';

export class ModuleEditingModel {
	@observable
	public courseModulePackages: ModulePackage[] = [];

	@observable
	public allModulePackages: ModulePackage[] = [];

	@observable
	public disableAddModuleButton = false;

	@observable
	public openModulePackageId: string | undefined = undefined;

	@observable
	public modulePackage: ModulePackage = {
		id: '',
		name: '',
		description: '',
		image: {
			src: '',
			alt: '',
		},
	};

	@observable
	public menuItems: MenuItemType<ModulePackage>[] = [];

	@observable
	public showDetailImage = false;

	constructor() {
		makeObservable(this);
	}

	@action
	setAllModulePackages(modulePackages: ModulePackage[]): void {
		this.allModulePackages = modulePackages;
	}

	@action
	setCourseModulePackages(courseModulePackages: ModulePackage[]): void {
		this.courseModulePackages = courseModulePackages;
	}

	@action
	setDisableAddModuleButton(value: boolean): void {
		this.disableAddModuleButton = value;
	}

	@action
	setModulePackage(modulePackage: ModulePackage): void {
		this.modulePackage = modulePackage;
	}

	@action
	setMenuItems(menuItems: MenuItemType<ModulePackage>[]): void {
		this.menuItems = menuItems;
	}

	@action
	setShowDetailImage(bool: boolean): void {
		this.showDetailImage = bool;
	}

	@action
	setOpenModulePackageId(openModulePackageId: string | undefined): void {
		this.openModulePackageId = openModulePackageId;
	}
}
